import { Box, Checkbox, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import utilFunctions from "../../../utilities/utilFunctions";
import { productSizeTypes } from "../../../clients/inventoryObjects";

const ReadOnlyIngredientRow = ({ ingredient, tableCellStyle }) => {
  const getQuantityDisplay = () => {
    if (
      ingredient.quantity?.unitOfMeasurement === null &&
      ingredient.quantity?.type !== productSizeTypes.Arbitrary
    ) {
      return "—";
    }

    return (
      <Box
        sx={{
          height: "20px",
          backgroundColor: (theme) => theme.palette.info[600],
          borderRadius: 1,
          padding: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "fit-content",
          marginLeft: 2,
        }}
      >
        <Typography
          variant="overline"
          noWrap
          sx={{
            color: (theme) => theme.palette.pure.white,
            fontWeight: 700,
          }}
        >
          {ingredient.quantity?.amount || ""}{" "}
          {utilFunctions.extractRecipeQuantityAbbreviation(ingredient.quantity)}
        </Typography>
      </Box>
    );
  };

  return (
    <TableRow>
      <TableCell sx={[tableCellStyle, { borderLeft: "none" }]}>
        {getQuantityDisplay()}
      </TableCell>
      <TableCell sx={tableCellStyle}>
        <Box sx={{ paddingLeft: 2 }}>
          <Typography variant="body1">
            {ingredient.menuDisplayName || "—"}
          </Typography>
        </Box>
      </TableCell>
      <TableCell sx={[tableCellStyle, { borderRight: "none" }]}>
        <Box
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Checkbox
            sx={{ color: (theme) => theme.palette.primary[800] }}
            checked={ingredient.isGarnish}
            disabled
            inputProps={{ "aria-label": "garnish" }}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default ReadOnlyIngredientRow;
